import EntryPoint from '../../EntryPoint';

export default new class MoneyFormat {
  format(value, showCurrency = true, hideFractionIfPossible) {
    let text = this.formatCurrency(value, EntryPoint.GameModel.currencyInfo.decimals, hideFractionIfPossible);
    if (showCurrency) {
      text = `${text} ${EntryPoint.GameModel.currencyInfo.symbol}`;
    }

    return text;
  }

  cut(value, decimals) {
    return OPUtility.utils.cutAmount(value, typeof decimals === 'number' ? decimals : EntryPoint.GameModel.currencyInfo.decimals)
  }

  cutAndSetSeparators(value, decimals, showCurrency = false) {
    const cutedValue = this.cut(value, decimals);
    return OPUtility.utils.formatCurrency(cutedValue, showCurrency ? EntryPoint.GameModel.currencyInfo.symbol : undefined);
  }

  formatCurrency(value, decimals, hideFractionIfPossible = true) {
    return OPUtility.utils.format(value, decimals, hideFractionIfPossible);
  }
};
